'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Label = require('stampy/lib/component/Label');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Label).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Label.js
// module id = 113
// module chunks = 35783957827783 114276838955818 162898551421021